import { styled } from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const Select = styled.select`
    flex-grow: 2;

    transition: all 0.25s;

    background-color: ${colourScheme.primary};
    color: ${colourScheme.white};
    border: 2px solid ${colourScheme.white};
    border-radius: 0.5rem;
    font-size: 1rem;
    min-height: 2rem;
    padding: 0.5rem;
    cursor: pointer;

    &:focus {
        outline: none;
        border-radius: 0.25rem;
        border-color: ${colourScheme.secondary};
        background-image: url("data:image/svg+xml;utf8,<svg transform='rotate(180)' fill='%23F4F5F6' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    }

    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='%23F4F5F6' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 98%;
    background-position-y: 0.5rem;
`;
